import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from './app/App'
import { ChromeProvider } from './app/theme'
import { SessionProvider } from './lib/session'
import './index.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // A console is read over a working day with the tab left open. Refetching on focus is how
      // an operator who alt-tabs back sees the state as it is now rather than as it was an hour
      // ago — which for a kill switch is the difference that matters.
      refetchOnWindowFocus: true,
      staleTime: 10_000,
      // One retry. A 403 or a 409 is an answer, not a failure to be hammered at.
      retry: (failureCount, error) => {
        const status = (error as { status?: number })?.status
        if (status && status < 500) return false
        return failureCount < 1
      },
    },
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ChromeProvider>
        <SessionProvider>
          <App />
        </SessionProvider>
      </ChromeProvider>
    </QueryClientProvider>
  </StrictMode>,
)
